import { Field, Text } from '@chakra-ui/react';

const FilterSelectLabel = ({ label, requiredMark }: { label: string, requiredMark?: boolean }) => (
  <Field.Label fontSize={14} color="gray.700" fontWeight={600}>
    {label}
    {requiredMark && <Text as="span" color="red.fg">*</Text>}
  </Field.Label>
);

export default FilterSelectLabel;
